module.exports = __webpack_public_path__ + "img/线上线下营销触达能力.11a5c91f.png";